import axios from 'axios';
import {configureEcho, echo} from '@laravel/echo-vue';
import {
  ChannelAuthorizationCallback,
  ChannelAuthorizationRequestParams,
} from 'pusher-js/src/core/auth/options.js';

// Add axios to window
declare global {
  interface Window {
    axios: typeof axios;
    mathVirtualKeyboard: any;
  }
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

configureEcho({
  broadcaster: 'reverb',
  key: 'stemble',
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: 80,
  wssPort: 443,
  forceTLS: true,
  enabledTransports: ['ws', 'wss'],
  // This ensures the CSRF token is sent with every request, as the axios client is configured to do so.
  // This is also important as the auth call is made to the app, not the reverb server.
  channelAuthorization: {
    transport: 'ajax',
    endpoint: '/broadcasting/auth',
    customHandler: (
      params: ChannelAuthorizationRequestParams,
      callback: ChannelAuthorizationCallback
    ): void => {
      axios
        .post('/broadcasting/auth', {
          socket_id: params.socketId,
          channel_name: params.channelName,
        })
        .then((response) => callback(null, response.data))
        .catch((error) => callback(error, null));
    },
  },
});
